import { ArrowUpRight } from "lucide-react";
import { Reveal, Kicker } from "@/components/Reveal";
import { useLanguage } from "@/i18n/LanguageContext";
import { IMG } from "@/constants/assets";

export function Products() {
  const { t } = useLanguage();
  const items = [
    { title: t("p1"), desc: t("p1d"), img: IMG.window, testid: "product-card-fenetres", span: "md:col-span-7" },
    { title: t("p2"), desc: t("p2d"), img: IMG.door, testid: "product-card-portes-entree", span: "md:col-span-5" },
    { title: t("p3"), desc: t("p3d"), img: IMG.interior, testid: "product-card-portes-interieures", span: "md:col-span-4" },
    { title: t("p4"), desc: t("p4d"), img: IMG.sliding, testid: "product-card-portes-coulissantes", span: "md:col-span-4" },
    { title: t("p5"), desc: t("p5d"), img: IMG.shutter, testid: "product-card-volets", span: "md:col-span-4" },
  ];

  return (
    <section id="creations" data-testid="products-section" className="relative py-28 md:py-40 bg-[#14120F]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div>
            <Reveal><Kicker>{t("prod_kicker")}</Kicker></Reveal>
            <Reveal delay={0.1}>
              <h2 className="font-serif-d text-4xl md:text-6xl mt-6 text-[#F7F4EE]">{t("prod_title")}</h2>
            </Reveal>
          </div>
          <Reveal delay={0.2}>
            <p className="text-sm text-[#B8B0A2] max-w-xs md:text-right">{t("prod_sub")}</p>
          </Reveal>
        </div>

        <div className="mt-16 grid md:grid-cols-12 gap-6">
          {items.map((item, i) => (
            <Reveal key={item.testid} delay={i * 0.08} className={`${item.span} group`}>
              <a href="#expression" data-testid={item.testid} className="block img-frame relative h-72 md:h-96">
                <img src={item.img} alt={item.title} className="w-full h-full object-cover" loading="lazy" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0B0A08]/95 via-[#0B0A08]/20 to-transparent" />
                <div className="absolute bottom-0 inset-x-0 p-6 md:p-8 flex items-end justify-between gap-4">
                  <div>
                    <h3 className="font-serif-d text-2xl md:text-3xl text-[#F7F4EE]">{item.title}</h3>
                    <p className="mt-2 text-xs md:text-sm text-[#B8B0A2] max-w-sm opacity-0 translate-y-3 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-500">
                      {item.desc}
                    </p>
                  </div>
                  <span className="shrink-0 w-11 h-11 border hairline flex items-center justify-center text-[#D4AF37] group-hover:bg-[#D4AF37] group-hover:text-[#0B0A08] group-hover:border-[#D4AF37] transition-all duration-400">
                    <ArrowUpRight size={17} />
                  </span>
                </div>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
